<template>
  <div class="footer center-align">
    Enduro Biking © 2023
    <br>
    <img class="logo" src="../../public/powered-by-strava.png" width="120px">
  </div>
</template>

<script>

  export default {
    name: 'Footer',
    components: {  },
    data() {
      return {

      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
